import { render, staticRenderFns } from "./VocabularyWords.vue?vue&type=template&id=448498dd&lang=pug&"
import script from "./VocabularyWords.vue?vue&type=script&lang=js&"
export * from "./VocabularyWords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports